import { styled, css } from 'app/pages/request-single-page/components-v4/theme';

export const Container = styled.div`
  ${({ theme }) => css`
    padding-block: ${theme.spacings.s};
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.base};
  `}
`;

export const ListWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.xs};
    width: 100%;
  `}
`;
